import { SITE_NAME, SITE_URL } from './siteConfig'

/** @typedef {{ title: string, description: string, path?: string, noindex?: boolean }} SeoEntry */

/** @type {Record<string, SeoEntry>} */
const staticRoutes = {
  '/': {
    title: `Dance Studio Newcastle | Kids & Adult Classes | ${SITE_NAME}`,
    description:
      'CC Choreography is a Newcastle dance studio offering kids and teen dance classes in Hamilton North and Lambton. Ballet, jazz, hip hop, acro & Lil Groovers. Free trial for new students.',
    path: '/',
  },
  '/about': {
    title: `About Us | Dance Teachers Newcastle NSW | ${SITE_NAME}`,
    description:
      'Meet the CC Choreography team in Newcastle NSW. Experienced teachers, Lil Groovers for ages 2–5, free trial week, and dance styles from ballet to hip hop at Hamilton North & Lambton.',
    path: '/about',
  },
  '/timetable': {
    title: `2026 Dance Class Timetable | Hamilton North & Lambton | ${SITE_NAME}`,
    description:
      'View the 2026 dance class timetable for CC Choreography (Hamilton North) and Tiny Tutus (Lambton). Kids ballet, jazz, acro, Lil Groovers and more in Newcastle.',
    path: '/timetable',
  },
  '/fees': {
    title: `Dance Class Fees Newcastle | ${SITE_NAME}`,
    description:
      'Dance class fees and private lesson prices at CC Choreography, Newcastle. Affordable kids dance classes in Hamilton North and Lambton with package discounts available.',
    path: '/fees',
  },
  '/testimonials': {
    title: `Reviews | Newcastle Dance Studio | ${SITE_NAME}`,
    description:
      'Read what Newcastle families say about CC Choreography. Reviews from parents about our kids dance classes, teachers, and welcoming studio culture.',
    path: '/testimonials',
  },
  '/gallery': {
    title: `Photo Gallery | ${SITE_NAME} Newcastle`,
    description:
      'Photos from CC Choreography dance concerts, classes and events in Newcastle. See our dancers in action at Hamilton North and Lambton studios.',
    path: '/gallery',
  },
  '/contact': {
    title: `Contact | Dance Studio Hamilton North & Lambton | ${SITE_NAME}`,
    description:
      'Contact CC Choreography in Newcastle. Visit us at Hamilton North (54 Clyde St) or Tiny Tutus Lambton (27 Wyong Rd). Email, phone and map directions.',
    path: '/contact',
  },
}

/**
 * @param {string} pathname
 * @returns {SeoEntry}
 */
export function getSeoForPath(pathname) {
  if (staticRoutes[pathname]) {
    return staticRoutes[pathname]
  }

  const galleryMatch = pathname.match(/^\/gallery\/([^/]+)$/)
  if (galleryMatch) {
    const slug = galleryMatch[1]
    const label =
      slug === 'danceevents'
        ? 'Dance Events'
        : slug.charAt(0).toUpperCase() + slug.slice(1)
    return {
      title: `${label} Photos | ${SITE_NAME} Gallery`,
      description: `View ${label} photos from CC Choreography dance studio in Newcastle NSW.`,
      path: pathname,
    }
  }

  return {
    title: SITE_NAME,
    description:
      'CC Choreography – kids and adult dance classes in Newcastle NSW at Hamilton North and Lambton.',
    path: pathname,
  }
}

export function canonicalUrl(path = '/') {
  const normalised = path === '/' ? '/' : path.replace(/\/$/, '')
  return `${SITE_URL}${normalised}`
}
